export default __webpack_public_path__ + "static/media/candids.ded30aa5.jpg";